// removed by extract-text-webpack-plugin
module.exports = {"pdpHeartItem":"PdpFavoriteItem-style__pdpHeartItem__cda73ab2","withCircle":"PdpFavoriteItem-style__withCircle__cda73ab2","heartComponentWrapper":"PdpFavoriteItem-style__heartComponentWrapper__cda73ab2"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItem-style.scss
// module id = 3442
// module chunks = 4